import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import type { TranslationHandler } from '@hunting-nature/shared-core/types/translation-handler.type';
import { executeAfterTranslationsLoad } from '@hunting-nature/shared-core/utils/execute-after-translations-load';
import { AppButtonComponent } from '@hunting-nature/shared-ui/components/app-button/app-button.component';
import type { AlertButton } from '@ionic/angular';
import { IonAlert, IonLabel } from '@ionic/angular/standalone';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';

import { SettingsActions } from '../../../../../../shared/redux/settings/settings.actions';

@Component({
  selector: 'app-delete-cache',
  templateUrl: './delete-cache.component.html',
  standalone: true,
  imports: [IonAlert, IonLabel, TranslocoPipe, CommonModule, AppButtonComponent],
})
export class DeleteCacheComponent {
  // services
  private readonly store = inject(Store);
  private readonly translocoService = inject(TranslocoService);

  // UI bindings
  protected readonly alertButtons: Array<AlertButton> = [
    {
      text: 'Cancel',
      role: 'cancel',
    },
    {
      text: 'OK',
      role: 'confirm',
      handler: () => this.handleDeleteCache(),
    },
  ];

  constructor() {
    executeAfterTranslationsLoad(this.handleTranslations.bind(this));
  }

  private readonly handleTranslations: TranslationHandler = () => {
    this.alertButtons[0].text = this.translocoService.translate('general.buttons.cancel');
    this.alertButtons[1].text = this.translocoService.translate('general.buttons.confirm');
  };

  // methods
  handleDeleteCache(): void {
    this.store.dispatch(SettingsActions.deleteFullAppCache());
  }
}
